module.exports = __webpack_public_path__ + "img/image-17.e5e0ad09.jpg";